<template>
    <div class="preparation-order-delivery-note">
        <div v-if="errorsSending" class="row mb-3 align-items-center">
            <div class="col-md-12">
                <errors-zone :errors="errorsSending"></errors-zone>
            </div>
        </div>
        <template v-if="orderReady">
            <div v-if="orderContainersValid" class="alert alert-warning text-center">
                <div class="my-2">
                    <div class="h4 m-0">
                        Préparation terminée !
                    </div>
                    <div class="h5 m-0 text-danger">
                        <i class="fad fa-arrow-circle-left"></i>
                        Vérifiez le nombre de contenants !
                    </div>
                    <div class="h5 m-0">
                        Imprimez et placez le bon de livraison dans un contenant.
                    </div>
                </div>

                <div class="text-center d-flex mt-2">
                    <div class="flex-fill">
                        <a class="btn btn-primary mt-2" :href="`/espace-employes/commandes/preparation/commande/${order.id}/bon-livraison/menu`">
                            <i class="fad fa-print"></i>
                            Imprimer le<br />
                            bon de livraison
                        </a>
                        <button class="btn btn-success mt-2" @click="confirmDeliveryNotePresent" :disabled="sending">
                            <i class="fad fa-check"></i>
                            Confirmer que le BL<br />
                            est dans le contenant
                        </button>
                    </div>
                    <div class="dropdown" v-if="(!order.customer.delivery_note_required && !order.online) || userPermissions.includes('force_order_without_delivery_note')">
                        <button class="btn btn-outline-danger mt-2" type="button" data-toggle="dropdown" :disabled="sending">
                            <i class="fad fa-times"></i>
                            Forcer sans<br />
                            bon de livraison
                        </button>
                        <div class="dropdown-menu dropdown-menu-right">
                            <button class="dropdown-item" @click="confirmDeliveryNoteNotNeeded">
                                Confirmer le forçage sans BL
                            </button>
                        </div>
                    </div>
                </div>
            </div>
            <div v-else class="alert alert-danger">
                <div class="h4">
                    Commande prête !
                </div>
                <div class="h5">
                    <i class="fad fa-arrow-circle-left"></i>
                    Indiquez le nombre de contenants avant de pouvoir imprimer le bon de livraison
                </div>
            </div>
        </template>
    </div>
</template>

<script>
    import ErrorsZone from "../ErrorsZone";

    import {orderContainersValid, orderReady} from "../../orders-utils";
    import {usePostRequest} from "../compositions/axios/postRequest";

    export default {
        name: 'PreparationOrderDeliveryNote',

        components: {
            ErrorsZone,
        },

        props: {
            order: {
                type: Object,
                required: true,
            },
        },

        setup() {
            const {
                loaded: sent,
                loading: sending,
                errors: errorsSending,
                post,
            } = usePostRequest();

            return {
                sent,
                sending,
                errorsSending,
                post,
            };
        },


        data() {
            return {};
        },

        methods: {
            confirmDeliveryNotePresent() {
                this.confirmDeliveryNote();
            },

            async confirmDeliveryNote() {
                const response = await this.post(`/espace-employes/commandes/preparation/commande/${this.order.id}/confirmer-bon-livraison`);

                if (!this.errorsSending) {
                    if (!this.$root.echoConnectedWihoutErrors) {
                        window.location.reload();
                    }
                }
            },

            async confirmDeliveryNoteNotNeeded() {
                if(confirm('Attention !'+"\n"+'Cette action marque la commande comme ne nécessitant pas de BL.'+"\n"+'La plupart du temps, cette action est anormale, confirmer ?')) {
                    const response = await this.post(`/espace-employes/commandes/preparation/commande/${this.order.id}/confirmer-bon-livraison-pas-necessaire`);

                    if (!this.errorsSending) {
                        if (!this.$root.echoConnectedWihoutErrors) {
                            window.location.reload();
                        }
                    }
                }
            },
        },

        computed: {
            orderReady,
            orderContainersValid,
        },
    }
</script>

<style lang="scss" scoped>
    .preparation-order-delivery-note {
    }
</style>
